import Slick from '@module/slick'

export default class OveApp {
  init () {
    initCounter();

    try {
      this.slick = new Slick()
    } catch(err) {}

    $('#shop .category-list>ul>li>.morecategories').on('click', function (event) {
      event.preventDefault()
      let main = $(this).closest('li')
      if (main.hasClass('open')) {
        main.removeClass('open')
      } else {
        main.addClass('open')
      }
    })

    // $('.nav-link.login').on('click', function (event) {
    //   event.preventDefault()
    //   $('.sidebars .backdrop').addClass('open')
    //   $('.sidebars .login-sidebar').addClass('open')
    //   $('body').addClass('modal-open')
    // })

    $('.login-sidebar .close-login').on('click touchstart', function (event) {
      event.preventDefault()
      $('.sidebars .backdrop').removeClass('open')
      $('.sidebars .login-sidebar').removeClass('open')
      $('body').removeClass('modal-open')
    })

    $('a[href="#"]').click(function(event) {
      if (event.target.getAttribute("href") === '#')
        event.preventDefault();
    });

    $(".nav a.search-link").click(function(event) {
      event.preventDefault();
      let searchbar = $("#header-search-form");
      if (searchbar.hasClass('open')) {
        searchbar.removeClass('open');
      }
      else
      {
        searchbar.addClass('open');
      }
    });

    $('input[name="searchtext"]').keypress(function (e) {
      if (e.which == 13) {
        $('#header-search-submit').click();
        return false;    //<---- Add this line
      }
    });

    $('#header-search-submit').click(function(event) {
      event.preventDefault();
      let searchUrl = '/suche/suche?id=176&tx_kesearch_pi1%5Bpage%5D=1&tx_kesearch_pi1%5BresetFilters%5D=0&tx_kesearch_pi1%5BsortByField%5D=&tx_kesearch_pi1%5BsortByDir%5D=&tx_kesearch_pi1%5Bsword%5D=';
      let shopUrl = '/shop/?run=true&searchterm=';
      let language = $('input[name="language"]').val();
      if (language == 'en') {
        shopUrl = '/shop/en/?run=true&searchterm=';
      }
      let searchinput = $('input[name="searchtext"]').val();
      let radioSelection = $('input[name="searchLocation"]:checked').val();
      console.log(radioSelection, searchinput);
      if (radioSelection === 'shop') {
        window.location.href = shopUrl + searchinput;
      }
      else {
        window.location.href = searchUrl + searchinput;
      }
    });

    $('.social-share-button').click(function(event) {
      event.preventDefault();
      $('.social-media-share').toggleClass('open');
    });

    $('[data-role="uservoice-slider"]').each((index, element) => {
      $(element).slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1200,
        arrows: false,
        dots: false,
        draggable: true,
        touchMove: true,
        fade: false,
        pauseOnHover: false,
        infinite: true,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: false
            }
          }
        ]
      })
    })

    $('.pages .opener a').click(function(event) {
      event.preventDefault()

      let pg = $('.pages')
      let opener = $('.pages .opener a')

      if (pg.hasClass('open')) {
        pg.removeClass('open')
        opener.html('Alles anzeigen <i class="fas fa-chevron-circle-down"></i>')
      }
      else
      {
        pg.addClass('open')
        opener.html('Alles verbergen <i class="fas fa-chevron-circle-up"></i>')
      }
    })

    $('#hamburg').change(function(event) {
      $('html').toggleClass('noscroll');
    });

    $('#mobile-menu .mobile-menu-opener').click(function(event) {
      event.preventDefault();
      let menupoint = $(event.target).closest('li.mainmenu-item');
      console.log(menupoint);
      let allitems = $('#mobile-menu li.mainmenu-item.open');
      console.log(allitems);
      if (!menupoint.hasClass('open')) {
        allitems.removeClass('open');
        menupoint.addClass('open');
      }
      else {
        allitems.removeClass('open');
      }
    })

    $(".frame-type-menu_sitemap_pages li").each(function () {
      if ($(this).has("ul").length) {
        $(this).addClass("hasSub")
      }
    })

    $(".hasSub").click(function() {
      $(this).toggleClass("active");
    })

    if (getQueryVariable("error") && (getQueryVariable("error") == "login" || getQueryVariable("error") == "blocked")) {
      const sidebarBackdrop = document.querySelector('.sidebars .backdrop');
      const sidebarLogin = document.querySelector('.sidebars .login-sidebar');
      const body = document.querySelector('body');

      var errormessage = document.querySelectorAll('div.login div.help-block.pw');
      if(getQueryVariable("error") == "blocked"){
        errormessage = document.querySelectorAll('div.login div.help-block.blocked');
      }

      if (!sidebarBackdrop.classList.contains('open')) {
        sidebarBackdrop.classList.add('open');
        sidebarLogin.classList.add('open');
        body.classList.add('modal-open');
        errormessage.forEach(
          function(currentValue, currentIndex, listObj) {
            currentValue.classList.remove('d-none');
          }
        );
      }
    }

    jQuery(function($) {

      // The speed of the scroll in milliseconds
      var speed = 1000;

      // Find links that are #anchors and scroll to them
      $('a[href^=\\#]:not(.pages)')
        .unbind('click.smoothScroll')
        .bind('click.smoothScroll', function(event) {
          event.preventDefault();
          let attr = $(this).attr('href')
          if (typeof attr !== typeof undefined && attr !== false) {
            $('html, body').animate({ scrollTop: $( attr ).offset().top }, speed);
          }
        });
    });
  }
}

function initCounter() {
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(window).scroll(function() {
    doCount();
  });

  $(document).ready(function() {
    doCount();
  });
}

function doCount() {
  $('.counter').each(function() {
    let a = 0;
    let top = $(this).offset().top - window.innerHeight;

    // if (a == 0 && $(window).scrollTop() > top) {
    if (a == 0 && $(this).isInViewport()) {
      $(this).find('.counter-value').each(function() {
        let $this = $(this),
        countTo = parseInt($this.attr('data-count').replace('.', ''));
        $({countNum: $this.text().replace('.', '')}).animate({
          countNum: countTo
        }, {
          duration: 2000,
          easing: 'swing',
          step: function() {
            $this.text(numberWithThousandSeparator(Math.floor(this.countNum)));
          },
          complete: function() {
            $this.text(numberWithThousandSeparator(this.countNum));
          }
        });
      });

      a = 1;
    } else {
      a = 0;
      $(this).find('.counter-value').each(function() {
        $(this).text(0);
      });
    }
  })
}

function numberWithThousandSeparator(x, separator = '.') {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}
